export default __webpack_public_path__ + "static/media/Total_Collected.065e7a15.svg";